var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartUnSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7695 2.23438C21.3286 0.793457 19.4131 0 17.3755 0C15.5737 0 13.8667 0.620606 12.4995 1.76074C11.1328 0.620606 9.42627 0 7.62451 0C5.58691 0 3.67139 0.793457 2.23096 2.23438C-0.743164 5.2085 -0.743164 10.0479 2.23096 13.022L10.5952 21.3862C11.1025 21.8936 11.7793 22.1729 12.5005 22.1729C13.2217 22.1729 13.8984 21.8936 14.4058 21.3862L22.77 13.022C25.7441 10.0479 25.7441 5.2085 22.77 2.23438H22.7695ZM21.7334 11.9858L13.3691 20.3501C13.1387 20.5806 12.8296 20.7075 12.5 20.7075C12.1704 20.7075 11.8613 20.5806 11.6309 20.3501L3.2666 11.9858C0.86377 9.58301 0.86377 5.67334 3.2666 3.27051C4.43066 2.10645 5.97803 1.46533 7.62451 1.46533C9.271 1.46533 10.8184 2.10645 11.9819 3.27051C12.2681 3.55664 12.7319 3.55664 13.0181 3.27051C14.1821 2.10645 15.7295 1.46533 17.376 1.46533C19.0225 1.46533 20.5698 2.10645 21.7334 3.27051C24.1362 5.67334 24.1362 9.58301 21.7334 11.9858Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22.1724,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartUnSelected);
export default __webpack_public_path__ + "static/media/heartUnSelected.23e0cfab23219e408ac7f2737be7f8ad.svg";
export { ForwardRef as ReactComponent };